// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// commented for tailwind implementation via
// https://layeredcraft.com/blog/the-complete-guide-for-developing-ghost-themes-with-tailwindcss/
// Import CSS
// import "../css/index.css";

// Import JS
// import menuOpen from './menuOpen'
// import infiniteScroll from './infiniteScroll'
import * as basicLightbox from 'basiclightbox';

window.basicLightbox = basicLightbox;
console.log("yeet")